<script>
    export let image = "drawer";
    export let label = "";
    export let isOpen = false;
    export let blocked = false;
    export let unclickable = false;
    export let title = "";
    export let state = "";

    let image_url = "";
    let width = 125;
    export let onClick = ()=>{};

    function clickFunc(){
        if(blocked) return;
        onClick();
    }

    let loadIconIndex = 0;

    $:{
        switch (image) {
            case "drops":
                image_url = "/images/Drops-Green-Circle.png";
                break;

            case "metamask":
                switch (state) {
                    case "initial":
                        image_url = "/images/fox_initial.png";
                        break;
                    case "loading":
                        image_url = "/images/fox_loading" + loadIconIndex + ".png";
                        break;
                    case "loaded":
                        image_url = "/images/fox_connected.png";
                        break;
                    case "error":
                        image_url = "/images/fox_error.png";
                        break;
                    case "network":
                        image_url = "/images/fox_network.png";
                        break;
                }
                break;

            case "drawer":
                if (!blocked) {
                    image_url = "/images/Drawer.png";
                } else {
                    image_url = "/images/Drawer_locked.png";
                }
                break;
        }
    }

    // <img src="/images/fox_initial.png" class="metamask_icon {state==='initial'?'':'hidden'}" alt="Metamask" />
    //     <img src="/images/fox_loading{loadIconIndex}.png" class="metamask_icon {state==='loading'?'':'hidden'}" alt="Metamask" />
    //     <img src="/images/fox_connected.png" class="metamask_icon {state==='loaded'?'':'hidden'}" alt="Metamask" />
    //     <img src="/images/fox_error.png" class="metamask_icon {state==='error'?'':'hidden'}" alt="Metamask" />
    //     <img src="/images/fox_network.png" class="metamask_icon {state==='network'?'':'hidden'}" alt="Metamask" />

    if(image === "metamask"){
        setInterval(()=>{
            loadIconIndex = (loadIconIndex+1)%2;
        },500);
    }


</script>

<style>
    .icon {
        width:120px;
        max-height:120px;
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-flow: column;
    }

    .drops_logo {
        width: 120px;
        height: 122px;
    }

    .metamask_icon {
        width: 70px;
        height: 65px;
    }

    .draw_icon {
        width: 70px;
        height: 39px;
    }

    .clickable {
        cursor: pointer;
    }

    .label {
        margin-top: 5px;
        margin-bottom: 22px;
        width:200px;
        color: white;
        font-size: 26px;
        text-shadow: -1px 3px black;
        white-space:nowrap;
        text-align: center;
    }

    .open {
        opacity: 0.5;
    }

</style>

<div class="icon {unclickable?'':'clickable'}" on:click={clickFunc}>

    {#if image == "metamask"}
        <img src="{image_url}" class="metamask_icon" alt="Metamask" />
    {:else if image == "drops"}
        <img src="{image_url}" class="drops_logo" alt="Logo" />
    {:else}
        <img src="{image_url}" class="draw_icon {isOpen?'open':''} {blocked?'blocked':''}" alt="Draw Icon" title={title} />
    {/if}

    <div class="label">{label}</div>
</div>